import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addCropMixComposerCrops } from "services";

import { ADD_CROP_MIX_COMPOSER_CROPS, GET_CROP_MIX_COMPOSER_CROPS } from "consts";

export const useAddCropMixComposerCrops = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [ADD_CROP_MIX_COMPOSER_CROPS],
    mutationFn: addCropMixComposerCrops,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CROP_MIX_COMPOSER_CROPS] });
    },
  });
};
